module.exports = __webpack_public_path__ + "img/homepage_phone2.696e9572.png";